import lazyScreen from '../utils/lazyScreen';
const ARTravel = lazyScreen(() => import('../pages/travel/ARTravel/index.js'), 'pages/travel/ARTravel/index.js');
const ARTravels = lazyScreen(() => import('../pages/travel/ARTravels/index.js'), 'pages/travel/ARTravels/index.js');
const ARTravelSessions = lazyScreen(() => import('../pages/travel/ARTravelSessions/index.js'), 'pages/travel/ARTravelSessions/index.js');

export default [
    {
        path: '/travel/ARTravels',
        component: ARTravels
    },
    {
        path: '/travel/ARTravel/:code',
        component: ARTravel
    },
    {
        path: '/travel/ARTravelSessions',
        component: ARTravelSessions
    }
];
